"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreciosOmieAjaxClient = void 0;
class PreciosOmieAjaxClient {
    constructor(ajaxUrl) {
        this.ajaxUrl = ajaxUrl;
    }
    async getCsrfToken() {
        // Try to get the CSRF token from cookies
        //console.log("Getting CSRF token from cookies");
        const match = document.cookie.match(new RegExp('(^| )__csrf_token=([^;]+)'));
        return match ? match[2] : null;
    }
    /**
     * Fetch OMIE prices for a given date.
     * @param date Date string in 'YYYY-MM-DD' format
     */
    async getData(date) {
        const formData = new FormData();
        formData.append('action', 'precios_omie_get_data');
        formData.append('date', date);
        const nonce = await this.getCsrfToken();
        if (!nonce) {
            return {
                success: false,
                message: 'CSRF token not found in cookies.',
            };
        }
        formData.append('nonce', nonce);
        const response = await fetch(this.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        });
        const json = await response.json();
        return json;
    }
}
exports.PreciosOmieAjaxClient = PreciosOmieAjaxClient;
